// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Q20m","bigColWidth":"Table_bigColWidth__2Br-_","biggerColWidth":"Table_biggerColWidth__fWKOR","row":"Table_row__1Uv4x","col":"Table_col__2iGIg"};